// ============================================================================
// Marketing landing: portal.stravo.ai/ when not logged in
// Section 0: LandingNav | Section 1: Hero | ... | Section 6: Security | Section 7: Final CTA
// ============================================================================

import { Link } from "react-router-dom";
import LandingNav from "@/components/landing/LandingNav";
import StickyStepsSection from "@/components/landing/StickyStepsSection";
import ToolsSection from "@/components/landing/ToolsSection";
import RoleSwitcherSection from "@/components/landing/RoleSwitcherSection";
import WhyChooseSection from "@/components/landing/WhyChooseSection";
import SecuritySection from "@/components/landing/SecuritySection";
import FinalCtaSection from "@/components/landing/FinalCtaSection";
import { Button } from "@/components/ui/button";

export default function Landing() {
  return (
    <div className="min-h-screen bg-background">
      <LandingNav />

      {/* Section 1 — Hero */}
      <section className="mx-auto w-full max-w-[900px] px-4 sm:px-6 py-12 sm:py-20 md:py-28 text-center min-w-0">
        <h1 className="text-3xl font-bold leading-tight tracking-tight text-foreground sm:text-5xl md:text-6xl break-words">
          Run turnovers on autopilot.
        </h1>
        <p className="mx-auto mt-4 sm:mt-6 max-w-[640px] text-base sm:text-lg md:text-xl text-muted-foreground break-words px-1">
          Stravo turns bookings into cleanings, checklists, and team assignments — so every property runs the same,
          every time.
        </p>
        <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row flex-wrap items-center justify-center gap-3">
          <Button size="lg" className="rounded-full w-full sm:w-auto" asChild>
            <Link to="/login?mode=signup">Start free</Link>
          </Button>
          <Button size="lg" variant="outline" className="rounded-full border-primary text-primary hover:bg-primary/10 w-full sm:w-auto" asChild>
            <a href="#demo">View demo</a>
          </Button>
        </div>
      </section>

      {/* Section 2 — From booking to completed clean (Sticky Steps timeline) */}
      <StickyStepsSection />

      {/* Section 3 — Tools that power cleanings */}
      <ToolsSection />

      {/* Section 4 — Role switcher */}
      <RoleSwitcherSection />

      {/* Section 5 — Why teams choose Stravo */}
      <WhyChooseSection />

      {/* Section 6 — Safe, secure & permissioned */}
      <SecuritySection />

      {/* Section 7 — Final CTA (Seeing is believing); #demo scroll target */}
      <FinalCtaSection />
    </div>
  );
}
